import * as authService from './authService';

export async function login({ username, password, otp }) {
    const data = await authService.login({ username, password, otp });
    return { data: { user: data.user, organization_id: data.organization_id } };
}

export async function getAccessToken() {
    return null;
}

export async function getRefreshToken() {
    return null;
}

export async function refreshToken() {
    await authService.refreshSession();
    return true;
}

export async function logout() {
    await authService.logout();
}
